export const DEFAULT_ENGAGEMENT_SORT_BY = 'total_requests';
export const DEFAULT_ENGAGEMENT_SORT_ORDER = 'desc' as const;

export const DEFAULT_TOOL_SORT_BY = 'calls';
export const DEFAULT_TOOL_SORT_ORDER = 'desc' as const;

export const DEFAULT_USER_SORT_BY = 'total_requests';
export const DEFAULT_USER_SORT_ORDER = 'desc' as const;

export const DEFAULT_CODEBASE_SORT_BY = 'total_requests';
export const DEFAULT_CODEBASE_SORT_ORDER = 'desc' as const;

export const DEFAULT_SERVICE_SORT_BY = 'requests';
export const DEFAULT_SERVICE_SORT_ORDER = 'desc' as const;

export const DEFAULT_MACHINE_SORT_BY = 'mcp_calls';
export const DEFAULT_MACHINE_SORT_ORDER = 'desc' as const;
